import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import store from "../store";
import News from "../views/News.vue";
import SingleNews from "../views/singleNews.vue";
import Articles from "../views/Articles.vue";
import SingleArticle from "../views/singleArticle.vue";
import Documents from "../views/Documents.vue";
import Contact from "../views/Contact.vue";
import Videos from "../views/Videos.vue";
import Events from "../views/Events.vue";
import NotFound from "../views/NotFound.vue";
import Pledge from "../views/Pledge.vue";
import WhoIsDrAafia from "../views/WhoIsDrAafia.vue";
import WhoWeAre from "../views/WhoWeAre.vue";
import BackgrounderCase from "../views/BackgrounderCase.vue";
import SupportImam from "../views/SupportImam.vue";
import SupportMedicalCare from "../views/SupportMedicalCare.vue";
import Volunteer from "../views/Volunteer.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/news",
    name: "news",
    component: News,
  },
  {
    path: "/single-news",
    name: "single-news",
    component: SingleNews,
  },
  {
    path: "/articles",
    name: "articles",
    component: Articles,
  },
  {
    path: "/single-article",
    name: "single-article",
    component: SingleArticle,
  },
  // {
  //   path: "/single-articles",
  //   name: "single-article",
  //   component: function () {
  //     return import("../views/articles/gordun.vue");
  //   },
  // },
  {
    path: "/documents",
    name: "documents",
    component: Documents,
  },
  {
    path: "/contact",
    name: "contact",
    component: Contact,
  },
  {
    path: "/reports",
    name: "reports",
    component: () => import("../views/Reports.vue"),
  },
  {
    path: "/videos",
    name: "videos",
    component: Videos,
  },
  {
    path: "/events",
    name: "events",
    component: Events,
  },
  {
    path: "/votes",
    name: "votes",
    component: () => import("../views/Votes.vue"),
  },
  {
    path: "/pledge",
    name: "pledge",
    component: Pledge,
  },
  {
    path: "/who-is-dr-aafia",
    name: "who-is-dr-aafia",
    component: WhoIsDrAafia,
  },
  {
    path: "/who-we-are",
    name: "who-we-are",
    component: WhoWeAre,
  },
  {
    path: "/backgrounder-case",
    name: "backgrounder-case",
    component: BackgrounderCase,
  },
  {
    path: "/support-imam",
    name: "support-imam",
    component: SupportImam,
  },
  {
    path: "/support-medical-care",
    name: "support-medical-care",
    component: SupportMedicalCare,
  },
  {
    path: "/volunteer",
    name: "volunteer",
    component: Volunteer,
  },
  {
    path: "/register",
    name: "register",
    component: () => import("../views/Register.vue"),
  },
  {
    path: "/signup",
    name: "signup",
    component: () => import("../views/Signup.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: () => import("../views/Dashboard.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/update-profile",
    name: "update-profile",
    component: () => import("../views/UpdateProfile.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/ownership",
    name: "ownership",
    component: () => import("../views/Ownership.vue"),
  },
  {
    path: "/petition",
    name: "petition",
    component: () => import("../views/Petition.vue"),
  },
  {
    path: "/free-aafia-toolkit",
    name: "free-aafia-toolkit",
    component: () => import("../views/FreeAafiaToolkit.vue"),
  },
  {
    path: "/ramadan-appeal",
    name: "ramadan-appeal",
    component: () => import("../views/RamadanAppeal.vue"),
  },
  {
    path: "/fatwas",
    name: "fatwas",
    component: () => import("../views/Fatwas.vue"),
  },
  {
    path: "/change-password",
    name: "change-password",
    component: () => import("../views/ChangePassword.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    component: NotFound,
  },
  // {
  //   path: "/about",
  //   name: "about",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: function () {
  //     return import(/* webpackChunkName: "about" */ "../views/AboutView.vue");
  //   },
  // },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

router.beforeEach((to, from, next) => {
  // Directly check localStorage to avoid any Vuex-persist initialization race conditions on hard refresh
  const token = localStorage.getItem('auth_token');
  const userId = localStorage.getItem('user_id');
  const userData = localStorage.getItem('user_data');
  const isLoggedIn = (!!token && !!userData) || store.getters.isLoggedIn;

  if (to.matched.some((record) => record.meta.requiresAuth) && !isLoggedIn) {
    // If route requires auth and user is not logged in, redirect to home
    next({ name: "home" });
  } else if ((to.name === "login" || to.name === "register" || to.name === "signup") && isLoggedIn) {
    // If user is logged in and trying to access auth pages, redirect to dashboard
    next({ name: "dashboard" });
  } else {
    next();
  }
});

export default router;
